module.exports = __webpack_public_path__ + "img/plswait2.c41cdb25.gif";